import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import video_input from '../assets/images/video_input.png'
import PresentationExample from '../assets/images/PresentationExample.png'
import RegionExample from '../assets/images/RegionExample.png'
import ScrollListExample from '../assets/images/ScrollListExample.png'
import captions from '../assets/images/captions.png'
import spacex_analysis from '../assets/blog/spacex_analysis.png'
import { Helmet } from 'react-helmet';

// Mock data for blog posts
const posts = [
  {
    id: 'spacex-launch-data-capture',
    title: 'Capturing Spacex Launch Data from Livestream',
    subtitle: 'Using video OCR to extract on-screen spacecraft data from YouTube livestream.',
    date: 'April 24, 2024',
    photo: spacex_analysis,
  },
  {
    id: 'transcription-vs-extraction',
    title: 'Transcription vs Character Extraction with OCR',
    subtitle: 'Extracting text from video frames is the next step past simple audio transcription.',
    date: 'April 15, 2024',
    photo: video_input,
  },
  { 
    id: 'ev-charge-curve-analysis',
    title: 'EV Charge Curve Analysis',
    subtitle: 'Analyzing electric vehicle charge curves efficiently with automated text extraction.',
    date: 'April 12, 2024',
    photo: video_input,
  },
  {
    id: 'presentation-text-extraction',
    title: 'Presentation Video Text Extraction',
    subtitle: 'Screen recordings of slideshow presentations are common, but being able to search and copy/paste the contents was difficult, until now.',
    date: 'April 5, 2024',
    photo: PresentationExample,

  },
  {
    id: 'caption-extraction',
    title: 'Video Caption Extraction with Video OCR',
    subtitle: 'Captions are often trapped in video frames, but Textractify is here to save them.',
    date: 'April 1, 2024',
    photo: RegionExample,

  },
  {
    id: 'scroll-list-extraction',
    title: 'Scrolled List Extraction with Video OCR',
    subtitle: 'Textractify can extract items from a scrolled through screen recording of items.',
    date: 'Oct 8, 2025',
    photo: ScrollListExample,

  },
];

function BlogPage() {
    const navigate = useNavigate()
  return (
    <div className="container mx-auto p-5">
      <Helmet>
        <title>Textractify | Extract visible text from videos.</title>
        <meta name="description" content="Textractify Blog: use cases for the only visible text extractor tool." />
        <meta property="og:title" content="Textractify | Extract visible text from videos." />
        <meta property="og:description" content="Textractify Blog: use cases for the only visible text extractor tool." />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Textractify | Extract visible text from videos." />
        <meta name="twitter:description" content="Textractify Blog: use cases for the only visible text extractor tool." />
      </Helmet>
      <h1 className="text-3xl font-bold text-center mb-8">Blog</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map(post => (
          <div key={post.id} className="card bg-base-100 shadow-xl h-96">
            <figure className="pointer-events-auto hover:cursor-pointer" onClick={() => navigate(`${post.id}`)}><img src={post.photo} alt={post.title} /></figure>
            <div className="card-body">
              <h2 className="card-title">{post.title}</h2>
              <p>{post.subtitle}</p>
              <p className="text-sm text-gray-500">{post.date}</p>
              <div className="card-actions justify-end">
                <Link to={`/blog/${post.id}`} className="btn btn-primary">View Post</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogPage;
